import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function AnnouncementFilled(props) {
  const clipPathId = useClipPathId("announcement-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M4.16906 17.367C3.63766 17.2608 3.10626 17.5796 2.99998 18.111C2.8937 18.6424 3.21254 19.1738 3.74394 19.2801C5.23186 19.5989 6.40094 20.768 6.71978 22.2559C6.82606 22.6811 7.25119 22.9999 7.67631 22.9999C7.78259 22.9999 7.78259 22.9999 7.88887 22.9999C8.42027 22.8936 8.73911 22.3622 8.63283 21.8308C8.20771 19.5989 6.40094 17.8984 4.16906 17.367Z"
            fill="currentColor"
          />
          <path
            d="M4.06284 13.4349C3.53144 13.3286 3.10632 13.7537 3.00004 14.2851C2.89376 14.8165 3.31888 15.2416 3.85028 15.3479C7.46381 15.773 10.2271 18.5363 10.6522 22.1498C10.7585 22.6812 11.0773 23.0001 11.6087 23.0001H11.715C12.2464 22.8938 12.5653 22.4687 12.5653 21.9373C12.0339 17.4735 8.52661 13.9663 4.06284 13.4349Z"
            fill="currentColor"
          />
          <path
            d="M3.95652 21.0869C3.42512 21.0869 3 21.512 3 22.0434C3 22.5748 3.42512 23 3.95652 23C4.48792 23 4.91304 22.5748 4.91304 22.0434C4.91304 21.512 4.48792 21.0869 3.95652 21.0869Z"
            fill="currentColor"
          />
          <path
            d="M19.686 1H5.44445C4.27537 1 3.31885 1.95652 3.31885 3.1256V10.8841C3.31885 11.4155 3.74397 11.8406 4.27537 11.9469C4.27537 11.9469 7.99518 12.6908 10.1208 14.8164C13.4155 18.1111 13.628 21.8309 13.628 21.9372C13.7343 22.4686 14.1594 22.7874 14.6908 22.7874H19.686C20.8551 22.7874 21.8116 21.8309 21.8116 20.6618V3.1256C21.8116 1.95652 20.8551 1 19.686 1ZM17.773 15.3478H15.3285C14.6908 15.3478 14.1594 14.9227 14.1594 14.285C14.1594 13.6473 14.6908 13.2222 15.3285 13.2222H17.773C18.4106 13.2222 18.942 13.6473 18.942 14.285C18.942 14.9227 18.4106 15.3478 17.773 15.3478ZM17.773 11.0966H8.9517C8.31402 11.0966 7.78262 10.5652 7.78262 10.0338C7.78262 9.50242 8.31402 8.97101 8.9517 8.97101H17.773C18.4106 8.97101 18.942 9.39614 18.942 10.0338C18.942 10.6715 18.4106 11.0966 17.773 11.0966ZM17.773 6.84541H8.9517C8.31402 6.84541 7.78262 6.31401 7.78262 5.78261C7.78262 5.25121 8.31402 4.71981 8.9517 4.71981H17.773C18.4106 4.71981 18.942 5.14493 18.942 5.78261C18.942 6.42029 18.4106 6.84541 17.773 6.84541Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width="18.8116"
              height={22}
              fill="white"
              transform="translate(3 1)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
